import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';

import socket from './socket.js';
import map from './map.js';
import numbers from './numbers.js';

/* Getting the show on the road */
document.addEventListener('DOMContentLoaded', () => {
	socket.init();
	numbers.init();
	map.init(() => {
		socket.initialiseWebsocket();
		socket.initialiseNumbersSocket();
		socket.initialiseMapSocket();
	});

	// Trigger resize handler above to draw the map initially
	window.dispatchEvent(new Event('resize'));

	// Convert SVGs to inline markup
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	});
});
